'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var PortfolioItemCollection = require('./PortfolioItemCollection');
var CartPortfolioItem = require('bunsen/models/portfolio/CartPortfolioItemModel');
var Items = require('bunsen/collections/inventory/Items');
var Storage = require('bunsen/helpers/storage');
var cartStorage = Storage.localStorage;

var LOCAL_STORAGE_ID = 'cart';

var LocalCartCollection = module.exports = PortfolioItemCollection.extend({
    model: CartPortfolioItem,

    comparator(modelOne, modelTwo) {
        var localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        var localCartIdsArr = _.map(localCart, function (item) {
            return item.id;
        });
        return _.indexOf(localCartIdsArr, modelTwo.get('item.id')) - _.indexOf(localCartIdsArr, modelOne.get('item.id'));
    },

    fetch(options) {
        var cartItems = cartStorage.getItem(LOCAL_STORAGE_ID);
        var numItems = options ? options.numberOfItems : false;
        var items;
        var itemIdsArr;
        var appendItemIdsArr = [];

        if (!cartItems || !cartItems.length || this.length === cartItems.length) {
            return $.Deferred().resolve();
        }
        itemIdsArr = cartItems.map(function (item) { return item.id; });
        items = new Items();
        if (numItems) {
            appendItemIdsArr = itemIdsArr.slice(0, -numItems);
            itemIdsArr = itemIdsArr.slice(-numItems);
        }
        items.setParam('pk', itemIdsArr.join(' '), {filterQuery: true});
        return items.fetchWithParameters().done(data => {
            this.reset(
                data.result.items
                    .map(item => new CartPortfolioItem({ item }))
                    .concat(appendItemIdsArr.map(itemId => new CartPortfolioItem({ item: { id: itemId }}))));
        });
    },

    add(model, options) {
        var cartPortfolioItem = new CartPortfolioItem();
        var localCart;
        var itemExists;
        var duplicate;

        if (_.isUndefined(model)) {
            return;
        }

        if (_.isArray(model)) {
            model.forEach(singleModel => this.add(singleModel, options));
            return;
        }

        if (model instanceof CartPortfolioItem) {
            cartPortfolioItem = model;
        } else {
            cartPortfolioItem = new CartPortfolioItem();
            cartPortfolioItem.set({ item: model });
        }

        localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        if (localCart) {
            // check local storage for dupe
            itemExists = localCart.some(item => item.id === cartPortfolioItem.get('item.id'));
            if (!itemExists) {
                localCart.push({ id: cartPortfolioItem.get('item.id') });
                cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(localCart));
            }
        } else {
            localCart = [{ id: cartPortfolioItem.get('item.id')}];
            cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(localCart));
        }

        // check collection for dupe
        duplicate = this.find(existingModel => existingModel.get('item.id') === cartPortfolioItem.get('item.id'));
        if (duplicate) {
            // may not be necessary, but in case the newer model is inflated
            duplicate.set('item', cartPortfolioItem.get('item'));
            return;
        }

        return LocalCartCollection.__super__.add.call(this, cartPortfolioItem, options);
    },

    remove(model, options) {
        var localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        var updatedCart;

        if (_.isArray(model)) {
            model.forEach(singleModel => this.remove(singleModel, options));
            return;
        }
        updatedCart = localCart ? localCart.filter(item => item.id !== model.get('item.id')) : undefined;
        if (updatedCart) {
            cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(updatedCart));
        }
        return LocalCartCollection.__super__.remove.call(this, model, options);
    },

    reset(models, options) {
        if (_.isUndefined(models)) {
            cartStorage.deleteItem(LOCAL_STORAGE_ID);
        }
        return LocalCartCollection.__super__.reset.call(this, models, options);
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/collections/portfolio/LocalCartCollection.es.js